export default {"src":"/_next/static/media/htc_logo.539287b3.svg","height":100,"width":237};